import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { currentTierSelector, planSelector, humanizeTier, humanizeMITierShortName, trialEndsInDaysSelector, isMiTrialSelector, isOnTrialStageSelector, isOnFreeStageSelector, isOnPaidStageSelector, isLegacyPlanSelector, isTrialActiveSelector, isEnterpriseSelector, hasMIaddonSelector } from 'features/billing';
import { UserMenuUpgradeButton } from './user-menu-upgrade-button';
const MAX_DAYS_TO_SHOW_TRIAL_BADGE = -30;
const MAX_DAYS_TO_SHOW_TEAMS_PLUS_TRIAL_BADGE = -21;
const menuHeaderContainerCss = "m1xhdzkn";
const MenuHeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(menuHeaderContainerCss, props.className)} />;
});
const headerContainerCss = "hpe2ctl";
const HeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerContainerCss, props.className)} />;
});
const userPlanContainerCss = "uowuvpp";
const UserPlanContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(userPlanContainerCss, props.className)} />;
});
const fitContentBadgeCss = "f5k8knf";
const FitContentBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fitContentBadgeCss, props.className)} />;
});
const planName = (tier, plan, hasMIAddon, isPaidStage, isTrialStage, organizationName, isMiTrial, isEnterprise) => {
  if (isEnterprise) {
    return isEmpty(organizationName) ? I18n.t('publisher.personal_settings.navigation.header.enterprise_plan') : I18n.t('publisher.personal_settings.navigation.header.enterprise_organization', {
      organization_name: organizationName
    });
  }
  const paidPlanName = hasMIAddon ? humanizeMITierShortName(plan) : humanizeTier(plan);
  if (isPaidStage) {
    return I18n.t('publisher.personal_settings.navigation.header.plan_name', {
      name: paidPlanName
    });
  }
  if (isTrialStage) {
    const trialTierHumanized = isMiTrial ? I18n.t('publisher.billing.meeting_intelligence.calendly_all_trial_humanized') : humanizeTier(tier);
    return I18n.t('publisher.personal_settings.navigation.header.trial', {
      name: trialTierHumanized
    });
  }
  return I18n.t('publisher.personal_settings.navigation.header.plan_name', {
    name: humanizeTier(tier)
  });
};
const TrialBadge = ({
  isTrialStage,
  trialEndsInDays,
  isMiTrial
}) => {
  let badgeText;
  if (isTrialStage) {
    badgeText = I18n.t('publisher.personal_settings.navigation.trial_badge.left_amount', {
      count: trialEndsInDays
    });
  } else {
    badgeText = isMiTrial ? I18n.t('publisher.personal_settings.navigation.trial_badge.teams_plus_ended') : I18n.t('publisher.personal_settings.navigation.trial_badge.trial_ended');
  }
  return <FitContentBadge>
      <Badge spacingBottom="0" spacingLeft="0" spacingRight="0" spacingTop="0" type={isTrialStage ? 'default' : 'warning'}>
        {badgeText}
      </Badge>
    </FitContentBadge>;
};
export const UserMenuHeader = ({
  userName,
  organizationName
}) => {
  const tier = useSelector(currentTierSelector);
  const plan = useSelector(planSelector);
  const trialEndsInDays = useSelector(trialEndsInDaysSelector);
  const isFreeStage = useSelector(isOnFreeStageSelector);
  const isTrialStage = useSelector(isOnTrialStageSelector);
  const isPaidStage = useSelector(isOnPaidStageSelector);
  const isAnOldTier = useSelector(isLegacyPlanSelector);
  const isMiTrial = useSelector(isMiTrialSelector);
  const isTrialActive = useSelector(isTrialActiveSelector);
  const isEnterprise = useSelector(isEnterpriseSelector);
  const hasMIAddon = useSelector(hasMIaddonSelector);
  const maxDaysToShowTrial = isMiTrial ? MAX_DAYS_TO_SHOW_TEAMS_PLUS_TRIAL_BADGE : MAX_DAYS_TO_SHOW_TRIAL_BADGE;
  const showTrialBadge = isTrialStage || isFreeStage && trialEndsInDays > maxDaysToShowTrial;
  return <MenuHeaderContainer>
      <HeaderContainer>
        <HeadingText level={3}>
          {' '}
          {userName}
          {' '}
        </HeadingText>
        <UserPlanContainer>
          <BodyText size="medium" color="muted">
            {planName(tier, plan, hasMIAddon, isPaidStage, isTrialStage, organizationName, isMiTrial, isEnterprise)}
          </BodyText>
          {!isEnterprise && <UserMenuUpgradeButton isUpgrade={isFreeStage || isAnOldTier || isTrialStage} trialEndsInDays={trialEndsInDays} />}
        </UserPlanContainer>
        {showTrialBadge && <TrialBadge isTrialStage={isTrialStage} isTrialActive={isTrialActive} trialEndsInDays={trialEndsInDays} isMiTrial={isMiTrial} />}
      </HeaderContainer>
    </MenuHeaderContainer>;
};

require("./user-menu-header.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./user-menu-header.js");